import { __extends, __bind } from "../../../config/javascript.js"

Pixlee.module('Entities', function(Entities, App, Backbone, Marionette, $) {
    Entities.Model = (function(_super) {
        var modelOptions = ['urlRoot', 'collection'];

        __extends(Model, _super);

        function onLoadingStart() {
            this.loading = true;
            this.trigger('loading:start');
        }

        function onLoadingStop() {
            this.loading = false;
            this.trigger('loading:stop');
        }

        function Model(options) {
            this.saveError = __bind(this.saveError, this);
            this.saveSuccess = __bind(this.saveSuccess, this);
            this.loading = false;
            options = options || {};
            _.extend(this, _.pick(options, modelOptions));
            
            Model.__super__.constructor.apply(this, arguments);
            this.listenTo(this, {
                'sync': onLoadingStop,
                'error': onLoadingStop,
                'request': onLoadingStart,
            });
        }

        Model.prototype.destroy = function(options) {
            options = options || {};
            _.defaults(options, {
                wait: true
            });
            this.set({
                _destroy: true
            }, {
                silent: true
            });
            return Model.__super__.destroy.call(this, options);
        };

        Model.prototype.isDestroyed = function() {
            return this.get('_destroy');
        };

        Model.prototype.save = function(key, val, options) {
            if (key == null || typeof key === 'object') {
                options = val;
            }
            var isNew;
            options = options || {};
            isNew = this.isNew();
            Cocktail.mixin(options, {
                wait: true,
                success: _.bind(this.saveSuccess, this, isNew, this.collection, options.index),
                error: _.bind(this.saveError, this)
            });
            this.unset('_errors');
            return Model.__super__.save.call(this, key, val, options);
        };

        Model.prototype.saveSuccess = function(isNew, collection, index) {
            if (isNew) {
                if (collection) {
                    collection.add(this, {
                        at: index || 0
                    });
                }
                if (collection) {
                    collection.trigger('model:created', this);
                }
                return this.trigger('created', this);
            } else {
                if (collection) {
                    collection.trigger('model:updated', this);
                }
                return this.trigger('updated', this);
            }
        };
        Model.prototype.saveError = function(model, xhr, options) {
            if (!(xhr.status === 500 || xhr.status === 404)) {
                var response = JSON.parse(xhr.responseText);
                return this.set({
                    _errors: response ? response.errors : undefined
                });
            }
        };

        return Model;

    })(Backbone.Model);

    Entities.DeepModel = (function(_super) {
        var modelOptions = ['urlRoot', 'collection'];

        __extends(Model, _super);

        function Model(options) {
            this.saveError = __bind(this.saveError, this);
            this.saveSuccess = __bind(this.saveSuccess, this);
            options = options || {};
            _.extend(this, _.pick(options, modelOptions));
            return Model.__super__.constructor.apply(this, arguments);
        }

        Model.prototype.destroy = function(options) {
            options = options || {};
            _.defaults(options, {
                wait: true
            });
            this.set({
                _destroy: true
            }, {
                silent: true
            });
            return Model.__super__.destroy.call(this, options);
        };

        Model.prototype.isDestroyed = function() {
            return this.get('_destroy');
        };

        Model.prototype.save = function(key, val, options) {
            if (key == null || typeof key === 'object') {
                options = val;
            }
            var isNew;
            options = options || {};
            isNew = this.isNew();
            Cocktail.mixin(options, {
                wait: true,
                success: _.bind(this.saveSuccess, this, isNew, this.collection, options.index),
                error: _.bind(this.saveError, this)
            });
            this.unset('_errors');
            return Model.__super__.save.call(this, key, val, options);
        };

        Model.prototype.saveSuccess = function(isNew, collection, index) {
            if (isNew) {
                if (collection) {
                    collection.add(this, {
                        at: index || 0
                    });
                }
                if (collection) {
                    collection.trigger('model:created', this);
                }
                return this.trigger('created', this);
            } else {
                if (collection) {
                    collection.trigger('model:updated', this);
                }
                return this.trigger('updated', this);
            }
        };
        Model.prototype.saveError = function(model, xhr, options) {
            if (!(xhr.status === 500 || xhr.status === 404)) {
                var response = JSON.parse(xhr.responseText);
                return this.set({
                    _errors: response ? response.errors : undefined
                });
            }
        };

        return Model;

    })(Backbone.DeepModel);
});
